import React, { PureComponent } from "react";

import BootstrapTable from "react-bootstrap-table-next";
import ToolkitProvider from "react-bootstrap-table2-toolkit/dist/react-bootstrap-table2-toolkit";
import moment from "moment";

import {
  // renderTrendTable,
  Error,
  selectFormat,
  MAIN_COLORS,
} from "components/Utils/Utils.js";

class WorldCupMatchStats extends PureComponent {
  componentDidMount() {
    this.props.childRef(this);
  }

  headerFormatter(column, colIndex, index) {
    const columnsToHide = [6, 8, 9, 11, 12, 13, 14, 15, 16, 17, 18, 19];
    const hideColumns = !columnsToHide.includes(colIndex);

    return (
      <div
        style={{
          backgroundColor: MAIN_COLORS[index],
          color: "#fff",
          padding: "5px",
        }}
      >
        {hideColumns && (
          <div
            style={{
              fontSize: "13px",
              textTransform: "uppercase",
              fontFamily: "Museo Slab W01",
              fontWeight: "bold",
            }}
          >
            {column.dataField.split(".")[0].split("_").join(" ")}
          </div>
        )}
        {column.text}
      </div>
    );
  }

  renderTable = (data) => {
    const { title } = this.props;

    // add unique ids
    data.forEach((d, i) => (d.id = i));

    const columns = [
      {
        dataField: "match",
        text: "Match",
        style: {
          width: "150px",
          minWidth: "150px",
          textAlign: "left",
          fontWeight: "bold",
        },
        headerAlign: "left",
      },
      {
        dataField: "date",
        text: "Date",
        style: { width: "80px", minWidth: "80px" },
        csvFormatter: (_, row) => row && moment(row.date).format("YYYY-MM-DD"),
        headerAlign: "left",
        csvExport: true,
        formatter: (_, row) => {
          return moment(row.date).format("YYYY-MM-DD");
        },
      },
      {
        dataField: "start_time",
        text: "Start Time",
        style: { width: "80px", minWidth: "80px" },
        headerAlign: "left",
      },
      {
        dataField: "network",
        text: "Network",
        style: { width: "60px", minWidth: "60px" },
        headerAlign: "left",
      },
      {
        dataField: "stage",
        text: "Stage",
        style: { width: "80px", minWidth: "80px" },
        headerAlign: "left",
      },
      {
        dataField: "cross_platform.tad",
        text: "Tad (000)",
        style: {
          width: "140px",
          minWidth: "140px",
          backgroundColor: "#f2f2f2",
        },
        headerAlign: "left",
        align: "center",
        formatter: (cell) => selectFormat("number", cell && cell, "0,0"),
        headerFormatter: (column, colIndex) =>
          this.headerFormatter(column, colIndex, 0),
      },
      {
        dataField: "cross_platform.total_minutes",
        text: "Total Minutes (000)",
        align: "center",
        style: {
          width: "120px",
          minWidth: "120px",
          backgroundColor: "#f2f2f2",
        },
        formatter: (cell) => selectFormat("number", cell && cell, "0,0"),
        headerFormatter: (column, colIndex) =>
          this.headerFormatter(column, colIndex, 0),
      },

      {
        dataField: "digital.uniques",
        text: "Live Uniques",
        align: "center",
        style: {
          width: "90px",
          minWidth: "90px",
          backgroundColor: "#f2f2f2",
        },
        formatter: (cell) => selectFormat("number", cell && cell, "0,0"),
        headerFormatter: (column, colIndex) =>
          this.headerFormatter(column, colIndex, 1),
      },

      {
        dataField: "digital.livestreams",
        text: "Livestreams",
        align: "center",
        style: {
          width: "90px",
          minWidth: "90px",
          backgroundColor: "#f2f2f2",
        },
        formatter: (cell) => selectFormat("number", cell && cell, "0,0"),
        headerFormatter: (column, colIndex) =>
          this.headerFormatter(column, colIndex, 1),
      },

      {
        dataField: "digital.total_minutes",
        text: "Live Minutes (000)",
        align: "center",
        style: {
          width: "120px",
          minWidth: "120px",
          backgroundColor: "#f2f2f2",
        },
        formatter: (cell) => selectFormat("number", cell && cell, "0,0"),
        headerFormatter: (column, colIndex) =>
          this.headerFormatter(column, colIndex, 1),
      },

      {
        dataField: "linear_p2.total_minutes",
        text: "Total Minutes (000)",
        align: "center",
        style: {
          width: "120px",
          minWidth: "120px",
          backgroundColor: "#f2f2f2",
        },
        formatter: (cell) => selectFormat("number", cell && cell, "0,0"),
        headerFormatter: (column, colIndex) =>
          this.headerFormatter(column, colIndex, 2),
      },

      {
        dataField: "linear_p2.sltv_program_average",
        text: "SLTV Program Average (000)",
        headerAlign: "left",
        align: "center",
        style: {
          width: "180px",
          minWidth: "180px",
          backgroundColor: "#f2f2f2",
        },
        formatter: (cell) => selectFormat("number", cell && cell, "0,0"),
        headerFormatter: (column, colIndex) =>
          this.headerFormatter(column, colIndex, 2),
      },
      {
        dataField: "linear_p2.match_window_average",
        text: "SLTV Match Window Average (000)",
        headerAlign: "left",
        align: "center",
        style: {
          width: "190px",
          minWidth: "190px",
          backgroundColor: "#f2f2f2",
        },
        formatter: (cell) => selectFormat("number", cell && cell, "0,0"),
        headerFormatter: (column, colIndex) =>
          this.headerFormatter(column, colIndex, 2),
      },

      // {
      //   dataField: "linear_p2.out_of_home_contribution",
      //   text: "Out of Home Contribution",
      //   headerAlign: "left",
      //   align: "center",
      //   style: {
      //     width: "150px",
      //     minWidth: "150px",
      //     backgroundColor: "#f2f2f2",
      //   },
      //   formatter: (cell) => selectFormat("number", cell && cell, "0,0"),
      //   headerFormatter: (column, colIndex) =>
      //     this.headerFormatter(column, colIndex, 2),
      // },

      // {
      //   dataField: "linear_p2.out_of_home_lift",
      //   text: "Out of Home Lift",
      //   headerAlign: "left",
      //   align: "center",
      //   style: {
      //     width: "100px",
      //     minWidth: "100px",
      //     backgroundColor: "#f2f2f2",
      //   },
      //   formatter: (cell) => selectFormat("number", cell && cell, "0.0%"),
      //   headerFormatter: (column, colIndex) =>
      //     this.headerFormatter(column, colIndex, 2),
      // },

      {
        dataField: "linear_p2.program_reach",
        text: "SLTV Program Reach (000)",
        headerAlign: "left",
        align: "center",
        style: {
          width: "150px",
          minWidth: "150px",
          backgroundColor: "#f2f2f2",
        },
        formatter: (cell) => selectFormat("number", cell && cell, "0,0"),
        headerFormatter: (column, colIndex) =>
          this.headerFormatter(column, colIndex, 2),
      },

      {
        dataField: "linear_p2.eltv_program_average",
        text: "ELTV Program Average (000)",
        headerAlign: "left",
        align: "center",
        style: {
          width: "160px",
          minWidth: "160px",
          backgroundColor: "#f2f2f2",
        },
        formatter: (cell) => selectFormat("number", cell && cell, "0,0"),
        headerFormatter: (column, colIndex) =>
          this.headerFormatter(column, colIndex, 2),
      },
      {
        dataField: "linear_p2.sltv_share",
        text: "SLTV Share",
        headerAlign: "left",
        align: "center",
        style: {
          width: "100px",
          minWidth: "100px",
          backgroundColor: "#f2f2f2",
        },
        formatter: (cell) => selectFormat("number", cell && cell, "0.0%"),
        headerFormatter: (column, colIndex) =>
          this.headerFormatter(column, colIndex, 2),
      },
    ];

    const filename = title.split(" ").join("_") || "spreadsheet";

    return (
      <ToolkitProvider
        keyField="id"
        data={data}
        columns={columns}
        striped={false}
        hover={false}
        bordered={false}
        exportCSV={{
          fileName: filename + ".csv",
          exportAll: false,
          onlyExportFiltered: true,
        }}
      >
        {(props) => (
          <BootstrapTable
            {...props.baseProps}
            {...props.csvProps}
            wrapperClasses="world-cup-sticky-table-header"
            ref={(el) => (this.childRef = el)}
          />
        )}
      </ToolkitProvider>
    );
  };

  builtInExportCSV = () => this.childRef;

  render() {
    const data = this.props.data.list || this.props.data.data;

    if (data.hasData === false) {
      return <Error minHeight={560} />;
    }

    return (
      <div className="world-cup-actual-estimates-table">
        {/* {this.renderTable(data)} */}
        {this.renderTable(data)}
      </div>
    );
  }
}

export default WorldCupMatchStats;
